// extracted by mini-css-extract-plugin
export default {"background":"styles_background__0Bmi-","backgroundCentered":"styles_backgroundCentered__bDRGt"};